import Connection from 'utils/connection';
import { GET_ADDITIONAL_DOMAINS } from 'constants/api';

const tools = {
  getDomains: () => {
    return Connection.get(GET_ADDITIONAL_DOMAINS);
  },
  createShortLink: (url, data) => {
    return Connection.post(url, data);
  },
};

export default tools;
